require('./validator');
import $ from 'jquery';
import validate from 'jquery-validation';
import { getTranslatedMessages } from '../../translates';
import { setupEsLocationSelects } from './es-location-helper';
import { addUTMParamsToForm } from '../../common/utmTracking';
validate;

function setupPhoneInput(container) {
    container.find('input[name="phone"]').on('input', function () {
        $(this).val($(this).val().replace(/\D/g, '').slice(0, 13));
    });
}

function setupBudgetForm() {
    var $budgetForm = $('.budget-form');
    var $btnSubmit = $budgetForm.find('.btn-submit');

    setInterval(function () {
        try {
            reloadCaptcha('contact');
        } catch (e) {
            console.log(e);
        }
    }, 60000);

    $budgetForm.validate({
        ignore: ':hidden',

        rules: {
            first_name: 'required',
            last_name: 'required',

            email: {
                required: true,
                email: true
            },

            phone: {
                required: true,
                minlength: 8,
                maxlength: 13,
            },

            es_province_id: {
                number: true,
                required: true
            },

            es_department_id: {
                number: true,
                required: true
            },

            es_city_id: {
                number: true,
                required: true
            },

            product_id: {
                number: true,
                required: true
            },

            message: {
                required: true,
                maxlength: 400
            },

            privacy: 'required',

            contact_subject_id: {
                number: true,
                required: true
            }
        },

        messages: getTranslatedMessages(),

        submitHandler: function (form, event) {
            if ($btnSubmit.hasClass('loading')) {
                return;
            }

            $btnSubmit.addClass('loading');

            event.preventDefault();
            event.stopPropagation();

            setTimeout(function () {
                $btnSubmit.removeClass('loading');
            }, 1000);

            addUTMParamsToForm(form);

            $.ajax({
                type: 'POST',
                url: $(form).data('action'),
                data: $(form).serialize(),

                success: function (data) {
                    form.reset();

                    $budgetForm.find('.form').addClass('hidden');
                    $budgetForm.find('.response').removeClass('hidden');
                    $budgetForm.find('.form-feedback').html(data);
                },

                error: function (data) {
                    $budgetForm.find('.form-feedback').empty();

                    $budgetForm
                        .find('.form-errors')
                        .html(
                            data.responseJSON && data.responseJSON.errors
                                ? Object.values(data.responseJSON.errors).map(function (v) { return v[0] + '<br>'; })
                                : data.responseJSON.message || data.responseText
                        )
                        .show({ duration: 0 });

                    try {
                        reloadCaptcha('contact');
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        }
    });

}

function initialize() {
    setupBudgetForm();
    setupPhoneInput($('.budget-form'));
    setupEsLocationSelects($('.budget-form'), {
        provinceName: 'es_province_id',
        departmentName: 'es_department_id',
        cityName: 'es_city_id',
        visibilityMode: true,
    });
}

initialize();
